import _cloneDeep from 'lodash/cloneDeep';

import {SUBMITTED, SUBMIT_ERROR, TEXT_CHANGE, SUPPORT_UPLOAD_SUCCESS} from "../actions/support";

const textError = 'Text must be at least 10 characters long';

const support = (state = { textError: null }, action) => {
    let newState = null;
    switch (action.type) {
        case TEXT_CHANGE:
            newState = _cloneDeep(state);
            newState.text = action.text;
            newState.textError = null;
            break;
        case SUBMITTED:
            newState = _cloneDeep(state);
            newState.submitted = true;
            newState.error = false;
            break;
        case SUPPORT_UPLOAD_SUCCESS:
            newState = _cloneDeep(state);
            newState.imageKey = action.json.key;
            break;
        case SUBMIT_ERROR:
            newState = _cloneDeep(state);
            if (action.connectionError) {
                newState.error = true;
            } else if (action.textLengthError) {
                newState.textError = textError;
            }
            break;
        default:
            return state;
    }
    return newState;
};

export default support;
